import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import FormControl from '@mui/material/FormControl';
import { UseScreen } from '../../hooks/UseScreen.hook';
import { useDispatch } from 'react-redux';
import { modalAction } from '../../redux/reducers/Modal';

const EditProduct = (props) => {

    const screenWidth = UseScreen();
    const dispatch = useDispatch();

  return (
    <>
        <Grid item xs={ 10 }>
            <h5 style={{ margin: '0' }}>Producto / Editar</h5>
        </Grid>
        <Grid item xs={ 12 }>
            <Grid container sx={{ py: 6 }}>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Status"
                        value={ (props.product.status) ? 'active' : 'inactive' }
                        >
                            <MenuItem value='active'>Activo</MenuItem>
                            <MenuItem value='inactive'>Inactivo</MenuItem>
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Nombre"
                        fullWidth
                        value={ props.product.name }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Marca"
                        fullWidth
                        value={ props.product.brand }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Código"
                        fullWidth
                        value={ props.product.code }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Precio de compra"
                        fullWidth
                        type='number'
                        value={ props.product.buyPrice }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Precio de venta"
                        fullWidth
                        type='number'
                        value={ props.product.sellPrice }
                    />
                </Grid>
                <Grid item xs={ 12 } className='pr-2'>
                    <PrimaryLightInput
                        label="Detalles"
                        fullWidth
                        multiline
                        rows={ (screenWidth > 500) ? 4 : 1}
                        value={ props.product.details }
                    />
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={ 12 } sx={{ mt: 2 }} textAlign='end' className='pr-2'>
            <PrimaryOutlinedButton onClick={ () => dispatch(modalAction())  }>Guardar</PrimaryOutlinedButton>
        </Grid>
    </>
  )
}

export default EditProduct